import { render } from "./xTrackAssetsPage.vue?vue&type=template&id=49dee530&scoped=true"
import script from "./xTrackAssetsPage.vue?vue&type=script&lang=js"
export * from "./xTrackAssetsPage.vue?vue&type=script&lang=js"

import "./xTrackAssetsPage.vue?vue&type=style&index=0&id=49dee530&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dee530"]])

export default __exports__